import { v4 as uuidv4 } from 'uuid';
import { isValidRole } from './ShopRole.js';

export class ShopMember {
    constructor({ id = uuidv4(), userId, shopId, role = 'Staff', status = 'pending', joinedAt = new Date().toISOString() }) {
        this.id = id;
        this.userId = userId;
        this.shopId = shopId;

        // Validate Role (Soft check for now)
        if (!isValidRole(role)) {
            console.warn(`[ShopMember] Invalid role assigned: ${role}. Defaulting to 'Staff'.`);
            this.role = 'Staff';
        } else {
            this.role = role;
        }

        this.status = status ? status.toLowerCase() : 'pending'; // 'active', 'inactive', 'pending'
        this.joinedAt = joinedAt;
    }
}
